import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71ae1413&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae1413",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ae1413')) {
      api.createRecord('71ae1413', component.options)
    } else {
      api.reload('71ae1413', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71ae1413&scoped=true&", function () {
      api.rerender('71ae1413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/car/index.vue"
export default component.exports